import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, map, throwError } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HttpClientService {
  private httpHeaders: HttpHeaders = new HttpHeaders();
  private httpOptions: { headers: HttpHeaders } = { headers: this.httpHeaders };

  constructor(private router: Router, private httpClient: HttpClient) {
    this.setHeaders();
  }

  private setHeaders(): void {
    const auth = localStorage.getItem('auth');
    if (auth) {
      const parsedAuth = JSON.parse(auth);
      const tenantCode = parsedAuth?.tenant?.tenantCode;
      const token = parsedAuth?.token;

      if (tenantCode) {
        this.httpHeaders = this.httpHeaders.set('Tenant', tenantCode);
      } else {
        this.httpHeaders = this.httpHeaders.set('Tenant', environment.defaultTenant);
      }
      if (token) {
        this.httpHeaders = this.httpHeaders.set('Authorization', `Bearer ${token}`);
      }
    } else {
      this.httpHeaders = this.httpHeaders.set('Tenant', environment.defaultTenant);
    }

    this.httpOptions = { headers: this.httpHeaders };
  }

  private handleError(error: HttpErrorResponse) {
    console.error('HttpClient Error:', error);
    if (error.status === 401) {
      this.router.navigate(['/session']);
    }

    return throwError(() => error);
  }

  get(url: string, params: HttpParams = new HttpParams()): Observable<any> {
    this.setHeaders();
    return this.httpClient.get(url, { headers: this.httpHeaders, params }).pipe(
      map(response => response),
      catchError(this.handleError.bind(this))
    );
  }

  post(url: string, data: any = {}, p0?: { headers: { 'Content-Type': string; }; }): Observable<any> {
    this.setHeaders();

    // const postHeaders = this.httpHeaders.set('Content-Type', 'application/json'); 
    const postHeaders = data instanceof FormData
  ? this.httpHeaders
  : this.httpHeaders.set('Content-Type', 'application/json');

    return this.httpClient.post(url, data, { headers: postHeaders }).pipe( 
      map(response => response),
      catchError(this.handleError.bind(this))
    );
  }
  put(url: string, data: any = {}): Observable<any> {
    this.setHeaders();
    const putHeaders = this.httpHeaders.set('Content-Type', 'application/json');
    return this.httpClient.put(url, data, { headers: putHeaders }).pipe(
      map(response => response),
      catchError(this.handleError.bind(this))
    );
  }

  delete(url: string): Observable<any> {
    this.setHeaders();
    return this.httpClient.delete(url, { headers: this.httpHeaders }).pipe(
      map(response => response),
      catchError(this.handleError.bind(this))
    );
  }
  deleteWithBody(url: string, body: any): Observable<any> {
    this.setHeaders();
    const postHeaders = this.httpHeaders.set('Content-Type', 'application/json');
    return this.httpClient.delete(url, {
      headers: postHeaders,
      body: body
    }).pipe(
      map(response => response),
      catchError(this.handleError.bind(this))
    );
  }

}
